import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import newspaperIcon from "@phosphor-icons/core/regular/newspaper.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const classNewsletter: Tool = {
    urlSlug: "class-newsletter",
    configName: "teacher-tool-class-newsletter",
    title: () => t`Class newsletter`,
    description: () =>
        t`Produce engaging newsletters to keep parents informed about class activities`,
    categories: [ToolCategories.Create],
    icon: newspaperIcon,
    color: color.fadedGreen24,
    layout: Layout.Coeditor,
    activitySlug: "activity-write-class-newsletter",
    reportingLabelId: "write-class-newsletter",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            label: () => t`What's the name of your class?`,
            description: () => t`e.g., Mrs. Ramirez' 6th grade English`,
            inputKind: "TEXT_BOX",
            required: true,
            variableName: "className",
        },
        {
            label: () => t`What did you do last week?`,
            description: () =>
                t`Add key learning objectives and activities your class completed in the past week. Bullet points are fine!`,
            inputKind: "TEXT_AREA",
            required: true,
            variableName: "learningActivitiesCompleted",
        },
        {
            label: () => t`What are you doing next week?`,
            description: () =>
                t`Add upcoming assignments, announcements, reminders, etc. Bullet points are fine!`,
            inputKind: "TEXT_AREA",
            required: true,
            variableName: "learningActivitiesFuture",
        },
        {
            label: () => t`Other guidelines for your newsletter (optional):`,
            description: () =>
                t`e.g., Add a fall season theme, include a Spanish translation for parents`,
            inputKind: "TEXT_BOX",
            variableName: "otherComments",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
